import { render, staticRenderFns } from "./ObligeeInfo.vue?vue&type=template&id=0fac3217"
import script from "./ObligeeInfo.vue?vue&type=script&lang=js"
export * from "./ObligeeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports